var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mensagem"},[_c('img',{staticClass:"erro-img",attrs:{"src":require("../assets/images/alert-error.png"),"alt":" alerta de erro "}}),_c('p',[_vm._v(" "+_vm._s(_vm.texto || 'Houve um erro ao carregar os resultados.')+" "),_c('br'),_vm._v("Por favor, recarregue a página. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }